import React from "react";
import { Link } from "react-router-dom";
import { styleByGroup } from "./calcV2";
import { getShort2 } from "./utilsV2";


const LEFT_GROUP = ['Left', 'G', 'S&D'];
const RIGHT_GROUP = ['EPP', 'ECR', 'PfE', 'ESN'];

const getCoalition = (groups: string[], name: string, groupStyle: string, parliamentSize: number, predictionSeats: PartyValue[]) => {
    const sum = predictionSeats.filter(x => groups.includes(x.group)).reduce((s, a) => a.value + s, 0);
    return <div className="margin12">
        {groups.map(x => <span key={x} className={"highlight " + styleByGroup(x)}>{x}</span>)}
        -
        <span className={"highlight " + styleByGroup(groupStyle)}>{name}: {sum}</span>&nbsp;
        {(sum >= 1 + Math.floor(parliamentSize/2)) ? <span className="dot groupG" /> : <span className="dot groupSD" />}
    </div>
}
export const getCoalitions = (predictionSeats: PartyValue[], parliamentSize: number, govs: GovernmentData) => {
    const govData = predictionSeats.filter(x => govs.Parties.includes(x.party));
    const sum = govData.reduce((s, a) => a.value + s, 0);

    return <div>
        <div className="margin12">
            <span className="highlight groupNi">all seats: {parliamentSize}</span>&nbsp;
            <span className="highlight groupNi">majority: {Math.round((parliamentSize+1)/2)}</span>&nbsp;
            <span className="highlight groupNi">government&nbsp;
                {sum >= 1 + parliamentSize/2 ? <span className="dot groupG" /> : <span className="dot groupSD" />}
            </span>
            &nbsp;{govData.map((x, i) => <span key={i} className={"highlight " + styleByGroup(x.group)}>{x.group}</span>)}
        </div>
        {[{ a: LEFT_GROUP, b: 'left', c: 'Left' },
            { a: ['G', 'S&D', 'RE'], b: 'center-left', c: 'S&D' },
            { a: ['S&D', 'RE', 'EPP'], b: 'center-left/right', c: 'RE' },
            { a: ['RE', 'EPP', 'ECR'], b: 'center-right', c: 'EPP' },
            { a: RIGHT_GROUP, b: 'right', c: 'PfE' },
        ].map(x => <div key={x.b}>{getCoalition(x.a, x.b, x.c, parliamentSize, predictionSeats)}</div>)}
    </div>
}

export const getLeftRightScore = (predictionSeats: PartyValue[]) => {
    const left = predictionSeats.filter(x => LEFT_GROUP.includes(x.group)).reduce((s, a) => a.value + s, 0);
    const right = predictionSeats.filter(x => RIGHT_GROUP.includes(x.group)).reduce((s, a) => a.value + s, 0);

    return <span>
        <span className="highlight groupLeft">left:&nbsp;{left}</span>
        <span className="highlight groupId">right:&nbsp;{right}</span>
    </span>
}

export const countryDiv = (countryStat: CountryStat) => {
    return countryDiv2(countryStat.Region ?? countryStat.Country);
}
export const countryDiv2 = (countryRegion: string) => {
    const short = getShort2(countryRegion);
    const shortName = short?.toLowerCase() ?? ("region/" + countryRegion);

    return <Link to={"/"+shortName}><span className="highlight hlFirst">
                <img src={"flags/" + shortName + ".png"} alt={countryRegion} height={14} />&nbsp;
                {countryRegion}
            </span>
        </Link>
}

export const ratingDiv = (value: number, min: number, max: number) => {
    const arr = Array(Math.max(1, Math.round(5 - 4 * (value - min)/(max - min)))).fill(0);
    return <span className="highlight groupNi">
        {arr.map((x, i) => <img key={i} src="/star.png" alt="star" height={12} />)}
    </span>
}

export const getClass = (group: string) => {
    switch (group) {
        case "Left": return "groupLeft";
        case "G": return "groupG";
        case "S&D": return "groupSD";
        case "RE": return "groupRe";
        case "EPP": return "groupEpp";
        case "ECR": return "groupEcr";
        case "PfE": return "groupId";
        case 'ESN': return "groupEsn";
        case "NI": return "groupNi";
        default: return "";
    }
}

export const space = <>&#32;</>;
